import { FunctionComponent } from 'react';

import styles from './DetailsCard.module.scss';

export type DetailsCardProps = {
  content?: React.JSX.Element;
  width?: string;
};

type FC = FunctionComponent<DetailsCardProps>;

const DetailsCard: FC = ({ content, width }: DetailsCardProps) => (
  <div className={styles.detailsContainer} style={{ width }}>
    {content}
  </div>
);

export default DetailsCard;
